import axios from "axios";

/* ============================================================
   BASE URL SETUP
============================================================ */
const RAW_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_ROOT = RAW_BASE.match(/\/api$/i) ? RAW_BASE : `${RAW_BASE}/api`;
const API_URL = `${API_ROOT}/proveedores`;

/* ============================================================
   HELPERS
============================================================ */
const pickFirst = (...vals) => {
  for (const v of vals) if (v !== undefined && v !== null) return v;
  return undefined;
};

// Normaliza lo que llega del backend
export function normalizarProveedor(p) {
  if (!p) return null;

  let st = pickFirst(p.estatus, p.Estatus, "");
  if (st === "A") st = "Activo";
  if (st === "I") st = "Inactivo";

  return {
    id: pickFirst(p.id, p.Id, 0),
    clave: pickFirst(p.clave, p.Clave, ""),
    rfc: pickFirst(p.rfc, p.Rfc, ""),
    nombre: pickFirst(p.nombre, p.Nombre, ""),
    direccion: pickFirst(p.direccion, p.Direccion, ""),
    colonia: pickFirst(p.colonia, p.Colonia, ""),
    ciudad: pickFirst(p.ciudad, p.Ciudad, ""),
    estado: pickFirst(p.estado, p.Estado, ""),
    cp: pickFirst(p.cp, p.Cp, ""),
    email: pickFirst(p.email, p.Email, ""),
    estatus: st,
    telefono: pickFirst(p.telefono, p.Telefono, ""),
  };
}

// Prepara datos antes de mandar al backend
function sanitizeForApi(p) {
  const out = { ...p };

  Object.keys(out).forEach((k) => {
    if (typeof out[k] === "string") out[k] = out[k].trim();
  });

  if (out.estatus === "Activo") out.estatus = "A";
  if (out.estatus === "Inactivo") out.estatus = "I";

  return out;
}

/* ============================================================
   PETICIONES HTTP
============================================================ */

const empresaId = () => Number(localStorage.getItem("empresaId") || 0);

export const obtenerProveedores = () =>
  axios.get(API_URL, { params: { empresaId: empresaId() } });

export async function buscarProveedorPorClave(clave) {
  try {
    const { data } = await axios.get(`${API_URL}/by-clave`, { params: { clave, empresaId: empresaId() } });
    return normalizarProveedor(data);
  } catch (e) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

export const obtenerProveedor = (id) => axios.get(`${API_URL}/${id}`);

export const crearProveedor = (data) =>
  axios.post(API_URL, sanitizeForApi({ ...data, empresa: empresaId() }));

export const actualizarProveedor = (id, data) => {
  const payload = sanitizeForApi({ ...data, id });
  return axios.put(`${API_URL}/${id}`, payload);
};

export const eliminarProveedor = (id) => axios.delete(`${API_URL}/${id}`);
